import React from 'react'
import { Helmet } from 'react-helmet-async'

import captureException from 'utils/capture-exception'
import { usePageContext } from '@contexts/page-context'

const MetaData = ({ metaTitle, metaDescription, metaContent: metaContentProp, webpageSchema, preConnectUrl }) => {
  const {
    helmet: { canonical, metaContent }
  } = usePageContext()

  if (!metaTitle || !metaDescription) {
    captureException(`No title or header set, title: ${metaTitle}, metaDescription: ${metaDescription}`)
  }

  const metaContentOverride = metaContentProp || metaContent

  return (
    <Helmet>
      <title>{metaTitle}</title>
      <meta name='description' content={metaDescription} />
      {canonical && <link rel='canonical' href={canonical} />}

      {metaContentOverride &&
        Object.keys(metaContentOverride).map((property) => (
          <meta key={`meta-${property}`} name={property} content={metaContentOverride[property]} />
        ))}
      {webpageSchema && webpageSchema.map((schema) => <script type='application/ld+json'>{schema}</script>)}
      {preConnectUrl && <link href={preConnectUrl} rel='preconnect' crossorigin />}
    </Helmet>
  )
}

export default MetaData
